import React from 'react'

import LogoProyecto from './../../UI/Logos/logo-proyecto.svg'

interface Props{
    isLoading: boolean
    isWelcome: boolean
    handleHideWelcome: any
}

interface State{}

class WelcomeScreen extends React.Component<Props, State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(){
        return(
            <div className={this.props.isLoading || this.props.isWelcome ? "welcome-container fade-out":"welcome-container fade-in"}>
                <div className='logo-proyecto-container'>
                    <img src={LogoProyecto}/>
                </div>
                <div className='text-container'>
                    <div className='legal-text'>
                    Las imágenes contenidas en este documento, así como el mobiliario, acabados y demás elementos accesorios que aparecen en las mismas, son una representación ilustrativa del Proyecto y no comprometen contractualmente a Promotora La Ramada. En tal virtud, ésta se reserva el derecho de realizar cualquier modificación al Proyecto sin previo aviso. Las dimensiones técnicas y estructurales del Proyecto están sujetas a modificaciones.
                    </div>
                </div>
                <div className='btn-ingreso' onClick={() => {this.props.handleHideWelcome()}}>Ingresar</div>
            </div>
        )
    }
}

export default WelcomeScreen